module.exports = __webpack_public_path__ + "static/media/coffe-break.7e790d20.png";